<template>
  <div>
    <div class="ko-progress-circle" :data-progress="progress">
      <div class="ko-circle">
        <div class="full ko-progress-circle__slice">
          <div class="ko-progress-circle__fill"></div>
        </div>
        <div class="ko-progress-circle__slice">
          <div class="ko-progress-circle__fill"></div>
          <div class="ko-progress-circle__fill ko-progress-circle__bar"></div>
        </div>
      </div>
      <div class="ko-progress-circle__overlay" :style="`background-color: ${centerColor}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContDownCircle",
  props: ["percentage", "centerColor"],
  data() {
    return {
      progress: 0
    };
  },
  methods: {
    updateProgress(percent) {
      this.progress += percent;
    }
  }
};
</script>

<style lang="scss" scoped>
$circle-size: 200px;
$circle-background: #eee;
$circle-color: #f88;
$inset-size: 190px;
$inset-color: white;
$transition-length: 0.25s;

.ko-progress-circle {
  z-index: 100;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: $circle-size;
  height: $circle-size;

  background-color: $circle-background;
  border-radius: 50%;
  .ko-progress-circle__slice,
  .ko-progress-circle__fill {
    width: $circle-size;
    height: $circle-size;
    position: absolute;
    transition: transform $transition-length;
    border-radius: 50%;
  }
  .ko-progress-circle__slice {
    clip: rect(0px, $circle-size, $circle-size, $circle-size/2);
    .ko-progress-circle__fill {
      clip: rect(0px, $circle-size/2, $circle-size, 0px);
      background-color: $circle-color;
    }
  }
  .ko-progress-circle__overlay {
    width: $inset-size;
    height: $inset-size;
    position: absolute;
    margin-left: ($circle-size - $inset-size)/2;
    margin-top: ($circle-size - $inset-size)/2;

    background-color: $inset-color;
    border-radius: 50%;
  }

  $i: 0;
  $increment: 180deg / 100;
  @while $i <= 100 {
    &[data-progress="#{$i}"] {
      .ko-progress-circle__slice.full,
      .ko-progress-circle__fill {
        transform: rotate($increment * $i);
      }
      .ko-progress-circle__fill.ko-progress-circle__bar {
        transform: rotate($increment * $i * 2);
      }
      $i: $i + 1;
    }
  }
}
</style>
